module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[93]458.cd5d24d.woff2";